/**
 * Head chrome a dash panel body reports to {@link HomeDashPanelComponent}.
 *
 * When {@link HomeDashPanelHeadChrome.showBack} is true, the section head shows a back control
 * immediately left of the collapse caret. Clicking it bumps {@link HomeDashPanelHeadBindings.headBackTick};
 * the body should reset to its initial view when that tick changes.
 */
export type HomeDashPanelHeadChrome = {
    showBack?: boolean;
    backTooltip?: string;
};

/** Optional bindings between {@link HomeDashPanelComponent} and a panel body. */
export type HomeDashPanelHeadBindings = {
    headBackTick: number;
};

export const HOME_DASH_PANEL_HEAD_CHROME_INITIAL: HomeDashPanelHeadChrome = {};
